import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage, ModalFormContainer
} from '..';
import { IdentityContext } from '../../context';
import { useUpdate } from '../../hooks';
import { Input } from '../basic-inputs/input';


export function BirthInfo() {
  const { person, update } = useContext(IdentityContext);
  const navigate = useNavigate();

  const { handleUpdate } = useUpdate('people');

  const handleSave = useCallback(async (event) => {
    event.preventDefault();
    const form = event.target.form;
    const data = new FormData(form);

    const payload = {
      birth_country: data.get('country'),
      birth_state: data.get('state'),
      birth_county: data.get('county'),
      birth_city: data.get('city')
    };

    if (Object.keys(payload).length === 0) {
      return;
    }

    await handleUpdate(person.id, payload);
    await update();

    navigate('#race');
  }, [ handleUpdate, navigate, person.id, update ]);

  const {
    birthCountry: country,
    birthState: state,
    birthCounty: county,
    birthCity: city
  } = person ?? ({} as Record<string, string>);

  const handleBack = useCallback((event) => {
    event.preventDefault();
    navigate('#address');
  }, [ navigate ]);

  return (
    <ModalFormContainer
      icon="calendar_month"
      header="Where were you born?"
      step={3}
      steps={4}
    >
      <Input id="country" type="text" label="Country" defaultValue={country} />
      <Input id="state" type="text" label="State" defaultValue={state} />
      <Input id="county" type="text" label="County" defaultValue={county} />
      <Input id="city" type="text" label="City" defaultValue={city} />
      <ErrorMessage message="" />
      <ButtonBar
        handlePrimary={handleSave}
        primaryText="Continue"
        handleSecondary={handleBack}
      />
    </ModalFormContainer>
  );
}
